"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "תוך כמה זמן מגיע מטפל סיעודי?",
  answer: "אנו מתחייבים להגעת מטפל סיעודי ישראלי תוך עד 5 שעות בלבד מרגע הפנייה, בפריסה ארצית מלאה לבית המטופל או לבתי החולים המובילים כמו איכילוב, שיבא ובילינסון."
}, {
  question: "האם המטפלים שלכם הם ישראלים?",
  answer: "כן, ב-Siudy אנו מעסיקים מטפלים ומטפלות ישראלים בלבד. אנו מאמינים ששפה משותפת ורקע תרבותי דומה חיוניים להענקת טיפול איכותי, מכבד ומקצועי."
}, {
  question: "האם ניתן לקבל שירות השגחה בבית חולים?",
  answer: "בהחלט. השירות שלנו כולל ליווי והשגחה צמודה בבתי חולים בכל רחבי הארץ, תוך עמידה בסטנדרטים של מוסדות כמו אסותא ואיכילוב, כולל משמרות לילה וסופי שבוע."
}, {
  question: "באילו אזורים בארץ אתם פועלים?",
  answer: "אנו מספקים שירותי סיעוד בפריסה ארצית – מתל אביב והמרכז, דרך בית חולים הדסה בירושלים, בית חולים רמב\"ם בחיפה, ועד ליישובים מרוחקים. המטפלים שלנו זמינים להגעה מהירה לכל נקודה."
}, {
  question: "מהם תנאי ההתקשרות והתשלום?",
  answer: "אצלנו אין צורך בחוזים ארוכי טווח או דמי הרשמה. השירות גמיש לחלוטין וניתן להזמנה לפי צורך – החל ממשמרות בודדות ועד ליווי רציף, בשיטת תשלום שקופה והוגנת."
}, {
  question: "כמה זמן לוקח לקבל מטפל סיעודי?",
  answer: <span>
        אנו מתחייבים למענה מהיר וזמינות של מטפל מקצועי בביתכם{" "}
        <Link to="/NursingCareNowPage" className="text-ring underline">
          עד 5 שעות בלבד
        </Link>{" "}
        מרגע הפנייה. ניתן לקרוא עוד על{" "}
        <Link to="/CaregiverServicePagesPage" className="text-ring underline">
          שירותי הסיעוד שלנו
        </Link>{" "}
        באתר.
      </span>
}, {
  question: "האם ניתן להזמין מטפל לילה?",
  answer: <span>
        כן, אנו מספקים זמינות מלאה 24/7. שירות{" "}
        <Link to="/CaregiverServicePagesPage2" className="text-ring underline">
          מטפל לילה
        </Link>{" "}
        נועד להעניק שקט נפשי למשפחה וטיפול צמוד למטופל בשעות הקטנות.
      </span>
}, {
  question: "מהו שיקום לאחר אשפוז?",
  answer: <span>
        שיקום לאחר אשפוז הוא תמיכה מקצועית בהחלמה הביתית, המבטיחה חזרה בטוחה לשגרה. למידע נוסף, בקרו ב
        <Link to="/ProfessionalBlogPage" className="text-ring underline">
          בלוג המקצועי שלנו
        </Link>{" "}
        הכולל מדריכים מפורטים.
      </span>
}, {
  question: "האם עובדים עם דמנציה וזקנות?",
  answer: <span>
        כן, הצוות שלנו מיומן בטיפול ממוקד במצבי דמנציה ואלצהיימר. אנו מביאים ניסיון מקצועי רב בטיפול במחלות ניווניות של המוח, תוך מתן דגש על סביבה בטוחה ותמיכה רגשית. אנו מציעים{" "}
        <Link to="/NursingCaregiverInCityImmediateSolutionWithinHoursPage" className="text-ring underline">
          פתרונות סיעוד מותאמים
        </Link>{" "}
        לצרכים המורכבים של הגיל השלישי המבוססים על שנות ניסיון בשטח.
      </span>
}, {
  question: "מה הוא טיפול שיקום לאחר אשפוז?",
  answer: <span>
        טיפול שיקום לאחר אשפוז כולל ליווי רפואי וסיעודי צמוד המותאם אישית למצב המטופל לאחר שחרור מבית החולים. המטרה היא להבטיח החלמה מהירה, מניעת סיבוכים וחזרה הדרגתית לתפקוד מלא בסביבה הביתית המוכרת. למידע על תוכניות השיקום שלנו, בקרו ב
        <Link to="/CaregiverServicePagesPage" className="text-ring underline">
          דף שירותי השיקום
        </Link>.
      </span>
}, {
  question: "האם אתם עובדים בבתי חולים כמו שיבא ואיכילוב?",
  answer: <span>
        כן, אנו מקיימים שיתופי פעולה הדוקים ומספקים שירותי השגחה וסיעוד בבתי החולים המובילים בישראל, ביניהם שיבא תל השומר, איכילוב, בילינסון, אסותא וסורוקה. הצוותים שלנו מכירים את הנהלים הפנימיים ומספקים מענה מיידי בתוך כותלי המוסד. פרטים נוספים ניתן למצוא ב
        <Link to="/CaregiverServicePagesPage" className="text-ring underline">
          דף שותפויות בתי החולים
        </Link>.
      </span>
}, {
  question: "מהו טיפול בדמנציה ואלצהיימר?",
  answer: <span>
        טיפול בדמנציה ואלצהיימר דורש גישה רגישה ומקצועית המשלבת השגחה בטיחותית עם תמיכה קוגניטיבית ורגשית. המטפלים שלנו עוברים הכשרות ייעודיות להתמודדות עם אתגרי הזיכרון והתקשורת המאפיינים מצבים אלו. אנו מזמינים אתכם לקרוא עוד ב
        <Link to="/NursingCaregiverInCityImmediateSolutionWithinHoursPage" className="text-ring underline">
          דף הטיפול בדמנציה
        </Link>.
      </span>
}, {
  question: "כמה עולה מטפל סיעודי לשעה?",
  answer: <span>
        עלות מטפל סיעודי משתנה בהתאם למורכבות הטיפול, שעות הפעילות (יום/לילה) ומיקום גיאוגרפי. אנו דוגלים בשקיפות מלאה ומספקים הצעת מחיר מפורטת ללא התחייבות ארוכת טווח. למידע מעודכן על תעריפים, בקרו ב
        <Link to="/ProfessionalBlogPage" className="text-ring underline">
          דף המחירון והעלויות
        </Link>.
      </span>
}, {
  question: "איך מתבצעת התאמת המטפל למטופל?",
  answer: <span>
        תהליך ההתאמה מתבצע על ידי צוות מקצועי הבוחן את הצרכים הרפואיים, הרקע התרבותי והעדפות האישיות של המטופל. אנו שמים דגש על חיבור אנושי ושפה משותפת כדי להבטיח נוחות מקסימלית. ניתן ללמוד עוד על התהליך ב
        <Link to="/CaregiverServicePagesPage" className="text-ring underline">
          דף התאמת מטפלים
        </Link>.
      </span>
}, {
  question: "האם יש זמינות בסופי שבוע ובלילות?",
  answer: <span>
        בהחלט, שירותי הסיעוד של Siudy זמינים 24 שעות ביממה, 7 ימים בשבוע, כולל שבתות וחגים. אנו מבינים שצרכי סיעוד יכולים לעלות בכל רגע נתון ומחזיקים צוותי כוננות למענה מיידי. למידע על זמינות, בקרו ב
        <Link to="/NursingCareNowPage" className="text-ring underline">
          דף זמינות השירות
        </Link>.
      </span>
}, {
  question: "מהם התנאים הרפואיים שאתם מטפלים בהם?",
  answer: <span>
        אנו מעניקים מענה למגוון רחב של מצבים רפואיים הכוללים דמנציה, אלצהיימר, ירידה תפקודית, החלמה מניתוחים, שיקום אורתופדי וטיפול תומך בקשישים. הצוות שלנו מיומן בטיפול במקרים מורכבים הדורשים השגחה צמודה. פירוט מלא מופיע ב
        <Link to="/CaregiverServicePagesPage" className="text-ring underline">
          סקירת המצבים הרפואיים
        </Link>.
      </span>
}, {
  question: "כיצד מבטיחים רמה רפואית גבוהה?",
  answer: <span>
        אנו מקפידים על סטנדרטים מחמירים הכוללים סינון קפדני של מטפלים, הכשרות תקופתיות ובקרה שוטפת על איכות הטיפול. כל מטפל עובר בדיקת רקע והסמכה מקצועית לפני תחילת העבודה. למידע על בקרת האיכות שלנו, בקרו ב
        <Link to="/ProfessionalBlogPage" className="text-ring underline">
          דף הבטחת איכות
        </Link>.
      </span>
}, {
  question: "איזה ציוד רפואי אתם מכירים?",
  answer: <span>
        המטפלים שלנו מנוסים בעבודה עם מגוון רחב של ציוד רפואי ביתי ומוסדי, כולל מכשירי ניטור, עזרי ניידות, וציוד עזר לנשימה והזנה. אנו מוודאים שהמטפל המגיע אליכם בקיא בשימוש בציוד הספציפי הנדרש. פרטים נוספים ב
        <Link to="/CaregiverServicePagesPage" className="text-ring underline">
          דף הציוד הרפואי
        </Link>.
      </span>
}, {
  question: "מהי ירידה תפקודית וכיצד מטפלים בה?",
  answer: <span>
        ירידה תפקודית היא מצב בו המטופל מתקשה בביצוע פעולות יומיומיות בסיסיות עקב גיל או מחלה. הטיפול שלנו מתמקד בשימור היכולות הקיימות, סיוע פיזי ומניעת הידרדרות נוספת תוך שמירה על כבוד המטופל. קראו עוד ב
        <Link to="/NursingCaregiverInCityImmediateSolutionWithinHoursPage" className="text-ring underline">
          דף הטיפול בירידה תפקודית
        </Link>.
      </span>
}, {
  question: "האם עובדים עם מטופלים עם דמנציה?",
  answer: <span>כן, הצוות שלנו מיומן בטיפול בדמנציה ואלצהיימר, עם ניסיון עם מוסדות כמו איכילוב וגריאטריה.</span>
}];
export default function Faq() {
  return <section data-section-id="180680" id="faq" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="bg-muted/30 backdrop-blur-sm rounded-lg p-8 md:p-12 lg:p-16 shadow-sm border border-border/50">
          <div className="text-center mb-12">
            <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-4 tracking-tight">
              שאלות נפוצות על שירותי סיעוד
            </h2>
            <p className="text-muted-foreground font-default text-lg max-w-2xl mx-auto leading-relaxed">
              כל מה שחשוב לדעת על שירותי הסיעוד המיידיים של Siudy – מטפלים ישראלים מקצועיים בזמינות של עד 5 שעות.
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="w-full space-y-4">
              {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card border border-border rounded-lg overflow-hidden shadow-sm data-[state=open]:shadow-md transition-all duration-200 last:border-b">
                  <AccordionTrigger className="px-6 py-5 hover:no-underline text-base md:text-lg font-default font-semibold text-primary [&>svg]:text-ring [&>svg]:size-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-6 pt-0 text-muted-foreground font-default text-base leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}